var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[(_vm.hasAccess())?[_vm._t("gated-content")]:(_vm.show_access_message)?[_c('b-alert',{staticClass:"mb-4",attrs:{"dismissible":"","fade":"","show":"","variant":"danger"}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" "+_vm._s(`You do not have access to ${_vm.denied_permissions} data.`)+"\n    ")])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }